<div class="popover-ctn">
      <ion-thumbnail  *ngFor="let lang of languageList">
        <ion-img src="/assets/image/flags/{{lang}}.svg" (click)="onSelect(lang)"></ion-img>
      </ion-thumbnail>
</div>
